module.exports = "<div *ngIf=\"widget\">\n    <celine-widget-container [widgetData]=\"widget\" [url]=\"widget.moduleUrl\" [widget]=\"widget.componentId\">\n    </celine-widget-container>\n</div>\n<div class=\"message\" *ngIf=\"loading && !error\">\n    <p class=\"info\">Loading Widget</p>\n</div>\n<div class=\"message\" *ngIf=\"!loading && error\">\n    <p class=\"info\">Error Loading Widget</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/celine/components/widget-frame/widget-frame.component.html
// module id = ./src/app/celine/components/widget-frame/widget-frame.component.html
// module chunks = 0